(function () {
  'use strict';

  var STORAGE_KEY = 'kala-orbit-motion-v1';
  var observer = null;

  function safeStorageGet() {
    try { return window.localStorage.getItem(STORAGE_KEY); } catch (_) { return null; }
  }

  function safeStorageSet(value) {
    try { window.localStorage.setItem(STORAGE_KEY, value); } catch (_) { /* private mode */ }
  }

  function initOrbitMotion() {
    var home = document.getElementById('KalaManusHome');
    if (!home) return false;

    var card = home.querySelector('.km-launch-visual');
    if (!card || card.dataset.kmOrbitRuntime === 'ready') return Boolean(card);

    card.dataset.kmOrbitRuntime = 'ready';
    card.classList.add('km-orbit-runtime');

    var wrapper = document.createElement('div');
    wrapper.className = 'km-launch-visual-wrap';
    card.parentNode.insertBefore(wrapper, card);
    wrapper.appendChild(card);

    var control = document.createElement('button');
    control.className = 'km-orbit-motion-control';
    control.type = 'button';
    control.setAttribute('aria-controls', 'kala-living-learning-orbit');
    control.innerHTML = '<span class="km-orbit-motion-control-icon" aria-hidden="true"></span><span class="km-orbit-motion-control-label"></span>';
    wrapper.appendChild(control);

    var note = document.createElement('span');
    note.className = 'km-orbit-motion-control-note';
    note.textContent = 'Motion is paused because this device requests reduced motion. You can play it here.';
    wrapper.appendChild(note);

    card.id = card.id || 'kala-living-learning-orbit';

    var reduceQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var stored = safeStorageGet();
    var reduced = Boolean(reduceQuery && reduceQuery.matches);
    var playing = stored === 'play' || (stored !== 'pause' && !reduced);
    var raf = 0;
    var startedAt = performance.now();
    var pausedAt = startedAt;
    var elapsedBeforePause = 0;

    var ringMotions = Array.prototype.slice.call(card.querySelectorAll('.km-orbit-ring-motion'));
    var ringGold = Array.prototype.slice.call(card.querySelectorAll('.km-orbit-ring-gold'));
    var crystal = card.querySelector('.km-orbit-crystal-bg');
    var facetsOne = card.querySelector('.km-crystal-facets-one');
    var facetsTwo = card.querySelector('.km-crystal-facets-two');
    var crystalLines = card.querySelector('.km-crystal-lines');
    var crystalCore = card.querySelector('.km-crystal-core');
    var aura = card.querySelector('.km-orbit-ambient-light');
    var planet = card.querySelector('.km-orbit-planet');
    var atmosphere = card.querySelector('.km-orbit-atmosphere');
    var polar = card.querySelector('.km-orbit-polar-glow');
    var wideShadow = card.querySelector('.km-orbit-shadow-wide');
    var contactShadow = card.querySelector('.km-orbit-shadow-contact');
    var stars = card.querySelector('.km-orbit-starfield');

    function updateControl() {
      control.setAttribute('aria-pressed', playing ? 'true' : 'false');
      control.setAttribute('aria-label', playing ? 'Pause orbit animation' : 'Play orbit animation');
      control.querySelector('.km-orbit-motion-control-label').textContent = playing ? 'Pause motion' : 'Play motion';
      card.classList.toggle('is-motion-playing', playing);
      wrapper.classList.toggle('is-reduced-default', reduced && !playing && stored !== 'pause');
    }

    function resetVisual() {
      card.style.setProperty('--km-live-y', '0px');
      card.style.setProperty('--km-live-z', '0deg');
      card.style.setProperty('--km-sat-one', '0deg');
      card.style.setProperty('--km-sat-two', '0deg');
      card.style.setProperty('--km-label-one', '0px');
      card.style.setProperty('--km-label-two', '0px');
      card.style.setProperty('--km-label-three', '0px');
      card.style.setProperty('--km-label-four', '0px');

      ringMotions.forEach(function (el) { el.style.strokeDashoffset = '0'; });
      ringGold.forEach(function (el) { el.style.strokeDashoffset = '0'; });
      if (crystal) crystal.style.transform = 'scale(1.035)';
      if (facetsOne) { facetsOne.style.opacity = '.94'; facetsOne.style.transform = 'scale(1)'; }
      if (facetsTwo) facetsTwo.style.transform = 'translate3d(0,0,0)';
      if (crystalLines) crystalLines.style.opacity = '.68';
      if (crystalCore) { crystalCore.style.opacity = '.76'; crystalCore.style.transform = 'scale(1)'; }
      if (aura) { aura.style.opacity = '.82'; aura.style.transform = 'translate(-50%,-50%) scale(1)'; }
      if (planet) planet.style.filter = 'saturate(1) brightness(1)';
      if (atmosphere) atmosphere.style.transform = 'rotate(0deg)';
      if (polar) { polar.style.opacity = '.5'; polar.style.transform = 'rotate(-7deg) scaleX(1)'; }
      if (wideShadow) { wideShadow.style.opacity = '.65'; wideShadow.style.transform = 'rotate(-12deg) skewX(-12deg) scale(.96)'; }
      if (contactShadow) { contactShadow.style.opacity = '.54'; contactShadow.style.transform = 'rotate(-11deg) scaleX(.94)'; }
      if (stars) stars.style.opacity = '.45';
    }

    function frame(now) {
      if (!playing) return;

      var elapsed = elapsedBeforePause + (now - startedAt);
      var seconds = elapsed / 1000;
      var floatY = -6 + Math.sin(seconds * 0.9) * 7;
      var lean = Math.sin(seconds * 0.36) * 0.65;
      var pulse = (Math.sin(seconds * 0.92) + 1) / 2;

      card.style.setProperty('--km-live-y', floatY.toFixed(2) + 'px');
      card.style.setProperty('--km-live-z', lean.toFixed(3) + 'deg');
      card.style.setProperty('--km-sat-one', ((seconds * 22) % 360).toFixed(2) + 'deg');
      card.style.setProperty('--km-sat-two', ((seconds * -13) % 360).toFixed(2) + 'deg');
      card.style.setProperty('--km-label-one', (Math.sin(seconds * .95) * 4.8).toFixed(2) + 'px');
      card.style.setProperty('--km-label-two', (Math.sin(seconds * .88 + 1.9) * 4.8).toFixed(2) + 'px');
      card.style.setProperty('--km-label-three', (Math.sin(seconds * .84 + 3.4) * 4.8).toFixed(2) + 'px');
      card.style.setProperty('--km-label-four', (Math.sin(seconds * .91 + 5.1) * 4.8).toFixed(2) + 'px');

      ringMotions.forEach(function (el, index) {
        var direction = index % 2 === 0 ? -1 : 1;
        el.style.strokeDashoffset = (direction * seconds * 86).toFixed(1);
      });
      ringGold.forEach(function (el, index) {
        var direction = index % 2 === 0 ? 1 : -1;
        el.style.strokeDashoffset = (direction * seconds * 58).toFixed(1);
      });

      if (crystal) {
        crystal.style.transform = 'scale(' + (1.035 + pulse * .012).toFixed(4) + ') translate3d(' + (Math.sin(seconds * .12) * 4).toFixed(2) + 'px,' + (Math.cos(seconds * .1) * 3).toFixed(2) + 'px,0)';
      }
      if (facetsOne) {
        facetsOne.style.opacity = (.9 + pulse * .1).toFixed(3);
        facetsOne.style.transform = 'scale(' + (1 + pulse * .008).toFixed(4) + ')';
      }
      if (facetsTwo) {
        facetsTwo.style.transform = 'translate3d(' + (Math.sin(seconds * .2) * 5).toFixed(2) + 'px,' + (Math.cos(seconds * .17) * 3).toFixed(2) + 'px,0)';
      }
      if (crystalLines) crystalLines.style.opacity = (.55 + pulse * .32).toFixed(3);
      if (crystalCore) {
        crystalCore.style.opacity = (.62 + pulse * .36).toFixed(3);
        crystalCore.style.transform = 'scale(' + (.9 + pulse * .2).toFixed(3) + ')';
      }
      if (aura) {
        aura.style.opacity = (.72 + pulse * .24).toFixed(3);
        aura.style.transform = 'translate(-50%,-50%) scale(' + (.95 + pulse * .1).toFixed(3) + ')';
      }
      if (planet) planet.style.filter = 'saturate(' + (1 + pulse * .07).toFixed(3) + ') brightness(' + (.99 + pulse * .035).toFixed(3) + ')';
      if (atmosphere) atmosphere.style.transform = 'rotate(' + ((seconds * 8) % 360).toFixed(2) + 'deg)';
      if (polar) {
        polar.style.opacity = (.38 + pulse * .32).toFixed(3);
        polar.style.transform = 'rotate(-7deg) scaleX(' + (.9 + pulse * .2).toFixed(3) + ')';
      }
      if (wideShadow) {
        wideShadow.style.opacity = (.68 - pulse * .17).toFixed(3);
        wideShadow.style.transform = 'rotate(-12deg) skewX(-12deg) scale(' + (.92 + pulse * .13).toFixed(3) + ')';
      }
      if (contactShadow) {
        contactShadow.style.opacity = (.58 - pulse * .16).toFixed(3);
        contactShadow.style.transform = 'rotate(-11deg) scaleX(' + (.9 + pulse * .15).toFixed(3) + ')';
      }
      if (stars) stars.style.opacity = (.32 + pulse * .3).toFixed(3);

      raf = window.requestAnimationFrame(frame);
    }

    function start() {
      if (playing && raf) return;
      playing = true;
      stored = 'play';
      safeStorageSet('play');
      startedAt = performance.now();
      wrapper.classList.remove('is-reduced-default');
      updateControl();
      raf = window.requestAnimationFrame(frame);
    }

    function pause(persist) {
      if (playing) {
        pausedAt = performance.now();
        elapsedBeforePause += pausedAt - startedAt;
      }
      playing = false;
      if (raf) window.cancelAnimationFrame(raf);
      raf = 0;
      if (persist) {
        stored = 'pause';
        safeStorageSet('pause');
      }
      updateControl();
    }

    control.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (playing) pause(true); else start();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden && playing) {
        if (raf) window.cancelAnimationFrame(raf);
        raf = 0;
        pausedAt = performance.now();
        elapsedBeforePause += pausedAt - startedAt;
      } else if (!document.hidden && playing && !raf) {
        startedAt = performance.now();
        raf = window.requestAnimationFrame(frame);
      }
    });

    if (reduceQuery && typeof reduceQuery.addEventListener === 'function') {
      reduceQuery.addEventListener('change', function (event) {
        reduced = event.matches;
        if (reduced && safeStorageGet() !== 'play') {
          pause(false);
          resetVisual();
          wrapper.classList.add('is-reduced-default');
        }
      });
    }

    updateControl();
    resetVisual();
    if (playing) {
      startedAt = performance.now();
      raf = window.requestAnimationFrame(frame);
    }

    return true;
  }

  function boot() {
    if (initOrbitMotion()) return;
    var home = document.getElementById('KalaManusHome');
    if (!home || observer) return;
    observer = new MutationObserver(function () {
      if (initOrbitMotion() && observer) {
        observer.disconnect();
        observer = null;
      }
    });
    observer.observe(home, { childList: true, subtree: true });
    window.setTimeout(function () {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
